import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { StatusMessage } from "../../components/status-message/statusMessage";
import { Page } from "../../components/page/page";
import { Form } from "../../components/form/form";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { PasswordInput } from "../../components/input/passwordInput";
import { useStore } from "../../hooks/use-store/useStore";
import { useApp } from "../../hooks/use-app/useApp";

export const ForgotPassword: React.FC<{}> = () => {
  const [emailSent, setEmailSent] = useState(false);
  const { localize } = useLocalization();

  if (emailSent) {
    return (
      <Page title={localize("sentEmail")}>
        <StatusMessage type="info">
          <span>{localize("login:resetEmailSent")}</span>
        </StatusMessage>
      </Page>
    );
  }

  return (
    <Page title={localize("login:resetPassword")} showLoginLink>
      <StatusMessage type="info">
        <span>{localize("login:resetText")}</span>
      </StatusMessage>
      <Form
        action="/reset-password"
        method="POST"
        actionLabel={localize("sendEmail")}
        onSuccess={setEmailSent}
      >
        <label>
          {localize("email")}
          <input
            type="email"
            name="email"
            placeholder="ola.nordmann@epost.no"
            required
          />
        </label>
      </Form>
    </Page>
  );
};

export const ResetPassword: React.FC = () => {
  const { localize } = useLocalization();
  const { token } = useStore().query;
  const app = useApp();
  const [ok, setOk] = useState<boolean>(false);
  const passwordRef = useRef<HTMLInputElement>(null);
  const confirmPasswordRef = useRef<HTMLInputElement>(null);

  function validatePassword() {
    const password = passwordRef.current;
    const confirmPassword = confirmPasswordRef.current;

    if (!password || !confirmPassword) {
      return;
    }

    if (password.value !== confirmPassword.value) {
      confirmPassword.setCustomValidity(localize("register:passwordMismatch"));
    } else {
      confirmPassword.setCustomValidity("");
    }
  }

  if (ok) {
    return (
      <Page title={localize("admin:changePassword")}>
        <StatusMessage type="success">
          <p>{localize("login:resetPasswordOk")}</p>
        </StatusMessage>
        <Link className="button" to={`/${app.name}/logg-inn`}>
          {localize("backToLogin")}
        </Link>
      </Page>
    );
  }

  return (
    <Page title={localize("admin:changePassword")}>
      <Form
        action="/change-password"
        method="POST"
        actionLabel={localize("save")}
        successMessage={localize("saved")}
        onSuccess={() => {
          setOk(true);
        }}
      >
        <PasswordInput
          label={localize("admin:newPassword")}
          ref={passwordRef}
          name="newPassword"
          autoComplete="new-password"
          required
          onChange={validatePassword}
        />
        <PasswordInput
          label={localize("register:confirmPassword")}
          ref={confirmPasswordRef}
          name="confirmPassword"
          autoComplete="new-password"
          required
          onChange={validatePassword}
        />
        <input type="hidden" name="token" value={token} />
      </Form>
    </Page>
  );
};
